import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { TooltipService } from '../services/tooltip.service';

@Directive({
  selector: '[appTooltip]',
  standalone: false
})
export class TooltipDirective {
  @Input('appTooltip') tooltipText: string | null = '';
  private tooltipId = `tooltip-${this.tooltipText}`;
  private tooltip: HTMLElement | null = null;

  constructor(
    private el: ElementRef,
    private tooltipService: TooltipService
  ) {}

  @HostListener('mouseenter')
  onMouseEnter() {
    if (this.tooltipText) {
      
      this.tooltip = document.createElement('div');
      this.tooltip.className = 'tooltip';
      
      const span = document.createElement('span');
      span.textContent = this.tooltipText;
      this.tooltip.appendChild(span);
      
      document.body.appendChild(this.tooltip);
      
      const rect = this.el.nativeElement.getBoundingClientRect();
      this.tooltip.style.top = `${rect.top + 5}px`;
      this.tooltip.style.left = `${rect.right + 10}px`;
      
      this.tooltipService.showTooltip(
        this.tooltipId,
        this.tooltipText,
        { x: rect.right + 10, y: rect.top }
      );
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.tooltip) {
      document.body.removeChild(this.tooltip);
      this.tooltip = null;
    }
    this.tooltipService.hideTooltip(this.tooltipId);
  }

  ngOnDestroy() {
    if (this.tooltip) {
      document.body.removeChild(this.tooltip);
    }
    this.tooltipService.destroyTooltip(this.tooltipId);
  }
}
